import { ScheduledMeta } from '@/types/amplience';

export const isScheduledItemExpired = <T extends string>(item: ScheduledMeta<T>): boolean => {
  return Date.now() > new Date(item.lifecycle?.expiryTime || item.edition?.end || 0).getTime();
};
